import { darkTheme } from '../../theme/tokens';

interface SpinnerProps {
  size?: number;
  color?: string;
  fullscreen?: boolean;
}

export function Spinner({ size = 28, color, fullscreen = false }: SpinnerProps) {
  const t = darkTheme;
  const stroke = color ?? t.accent;

  const spinner = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={{ animation: 'spin 0.8s linear infinite', display: 'block' }}
      aria-label="Loading"
      role="status"
    >
      <circle cx="12" cy="12" r="10" stroke={t.border} strokeWidth="2.5" fill="none" />
      <path
        d="M22 12a10 10 0 0 0-10-10"
        stroke={stroke}
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );

  if (!fullscreen) return spinner;

  return (
    <div
      style={{
        minHeight: '100vh',
        // Match the body bg variable so the fullscreen spinner follows the
        // active theme (set by ThemeSync) instead of hard-locking to dark.
        background: 'var(--bg)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {spinner}
    </div>
  );
}
